/**
 * Planner filter keys with cross-file consumers (config + mapper + store cascades).
 * Values live in the planner store's `filters` record (URL + localStorage persisted).
 */

/** Filter date range scoping ALL other filters ('yyyy-MM-dd:yyyy-MM-dd' single string) */
export const PLANNER_DATE_RANGE_FILTER_KEY = 'dateRange';

/** Availability filter: free (unassigned) h/day over the date range ('mode:hours') */
export const PLANNER_AVAILABILITY_FILTER_KEY = 'availability';

/** Billable availability filter: free BILLABLE h/day over the date range ('mode:hours') */
export const PLANNER_BILLABLE_AVAILABILITY_FILTER_KEY = 'billableAvailability';

/** Project status multiselect (wire ProjectStatus values) */
export const PLANNER_PROJECT_STATUS_FILTER_KEY = 'projectStatus';

/** Project probability filter ('mode:percent') — requires projectStatus=TENTATIVE */
export const PLANNER_PROJECT_PROBABILITY_FILTER_KEY = 'projectProbability';

/** Assignment probability filter ('mode:percent') */
export const PLANNER_ASSIGNMENT_PROBABILITY_FILTER_KEY = 'assignmentProbability';

/** Manager multiselect ('true' / 'false' option values) */
export const PLANNER_IS_MANAGER_FILTER_KEY = 'isManager';

/** Member's-manager multiselect (team-member ids; FILTER_OPTION_NO_VALUE = "no manager") */
export const PLANNER_MEMBER_MANAGER_FILTER_KEY = 'memberManager';

/** Project's-manager multiselect (team-member ids; FILTER_OPTION_NO_VALUE = "no manager") */
export const PLANNER_PROJECT_MANAGER_FILTER_KEY = 'projectManager';
